    
    var http_3d_Url = "https://s3-us-tozo-production.tozostore.com/App/h5_v3.1/"
    // var http_3d_Url = "https://s3-us-tozo-test-wr.tozostore.com/App/h5_v3.1/"
    //var http_3d_Url = "https://s3-us-tozo-production.tozostore.com/App/h5_v3.0/"
    var http_shopify_Img_Url = "https://cdn.shopify.com/s/files/"
    //var product_fun = http_3d_Url + "static/img/3D/X1_box_integration_03.glb"
    var product_fun = ""
    var product_color = "#666666"
      
    var loading_img = http_shopify_Img_Url + "1/0737/0578/3585/files/loading.png?v=1706340263"
    var icon = {
        imgSwitch: http_shopify_Img_Url + "1/0737/0578/3585/files/13604_2x_2eb2c987-d481-4a1e-b2aa-f366389bbe6e.png?v=1706340262",
        imgReset: http_shopify_Img_Url + "1/0737/0578/3585/files/1207_2x_d0cc8916-814d-48b1-b231-eacc58092174.png?v=1706340262",
        imgPlay: http_shopify_Img_Url + "1/0737/0578/3585/files/icon_Play_2x_5c4540b0-b37e-4622-a7f4-da10680df778.png?v=1706340262",
        imgPause: http_shopify_Img_Url + "1/0737/0578/3585/files/icon_Pause_2x_466068db-13c1-4165-9113-371624fd6750.png?v=1706340262"
    }

    //设置默认的产品参数
    var position_set = {
        x: 0,
        z: 200, //上下角度
        default: 100,//首次加载默认设置的大小
        maximum: 155,//设置相机距离原点的最近距离 限制物体大 镜头越近物体越大
        minimum: 350,//设置相机距离原点的最远距离  限制体小 镜头越远物体越小
        DirectionalLight: 'F1EECF' // 灯光颜色
    }
      

    var dataObj = {
        closeLoading: true,
        controls:'',//控制器
        scene:'',//元素
        renderer:'',//渲染器
        camera:'',
        productColor: '0x333333', //背景颜色
        //productColor: Number('0x' + this.product_color.substring(1, this.product_color.length)), //背景颜色
        //默认的物体大小和限制缩放大小
        positionSet: {
          x: 0,
          z: 20,
          default: 12,
          maximum: 18,
          minimum: 40,
          DirectionalLight: 'F1EECF' // 灯光颜色
        },
        lightingColor:'F1EECF',//DBDBD7
        if_paly: false,
        if_bg_color: false,
    }
    
    var imgSwitchImg = document.getElementById("imgSwitchImg"); //切换按钮
    var imgResetImg = document.getElementById("imgResetImg"); //重置按钮
    var PlayPauseImg = document.getElementById("PlayPauseImg"); //播放按钮
    var faileding = document.getElementById("faileding")

    if(imgSwitchImg){
        imgSwitchImg.src = icon.imgSwitch
    }
    if(imgResetImg){
        imgResetImg.src = icon.imgReset
    }
    if(PlayPauseImg){
        PlayPauseImg.src = icon.imgPause //默认播放
    }
      
    //播放暂停
    function PlayPauseFun(Play_type){
        console.log('dataObj.if_paly')
        var PlayText = document.getElementById("PlayText");
        var PauseText = document.getElementById("PauseText");
        if(Play_type != 'mountedFun'){
            dataObj.if_paly =! dataObj.if_paly
            if(dataObj.if_paly){
                PlayPauseImg.src = icon.imgPlay
                PlayText.style.display = 'block'
                PauseText.style.display = 'none'
            }else{
                PlayPauseImg.src = icon.imgPause
                PlayText.style.display = 'none'
                PauseText.style.display = 'block'
            }
            Play_Pause()
        }else{
            //首次默认
            PlayPauseImg.src = icon.imgPause
            PlayText.style.display = 'none'
            PauseText.style.display = 'block'
        }
        
        console.log('dataObj.if_paly')
        console.log(dataObj.if_paly)
    }
    
    // 销毁3d文件
    function destroy3D(name) {
        console.log("dataObj.scene1")
        console.log(dataObj.scene)
        // 停止渲染循环 // 关闭展示
        if(dataObj.renderLoop){
            cancelAnimationFrame(dataObj.renderLoop);
        }

        // 清除场景中的对象
        if(dataObj.scene){
            dataObj.scene.clear();
        }
        
        // 移除 Three.js 渲染器
        if(dataObj.renderer){
            dataObj.renderer.dispose();
            const app_box = document.getElementById('app_box') //从盒子删除3D
            if(app_box && dataObj.renderer.domElement){
                app_box.removeChild(dataObj.renderer.domElement);
            }
            // 解除domElement的引用
             dataObj.renderer.domElement = null;
        }
        // 渲染画布的盒子
        // 可选：手动清空其他资源，如材质、纹理等
        // ...
        // 重置变量
        
        //关闭3d展示
        if(name == 'close'){
            if(ThreeDShowBox){
                ThreeDShowBox.style.display = 'none'
            }
        }
        
        // dataObj.scene = null;
        // dataObj.renderer = '';
    }
    
    // 加载loading  
    function close_loading(type){
        dataObj.closeLoading = type == 'none' ? false : true
        let closeLoading = document.getElementById("closeLoading")
        closeLoading.style.display = type
    }

    //是否加载完成
    function go_is_Loading_completed(data){
        console.log(data)
        close_loading('none')
        if(data == '加载失败'){
            clickSwitch.style.display = 'none'
            clickReset.style.display = 'none'
            PlayPause.style.display = 'none'
            faileding.style.display = 'block'
            header_click.style.display = 'none'
        }else{
            clickSwitch.style.display = 'block'
            clickReset.style.display = 'block'
            PlayPause.style.display = 'block'
            faileding.style.display = 'none'
            //产品切换按钮图片
            if(current_product.is_multiple){
                header_click.style.display = 'block'
                product_box_img.src = current_product.product_box.img
                product_img.src = current_product.product.img
            }else{
                header_click.style.display = 'none'
            }
        }
       //console.log(this.product_fun)
       //this.is_Loading_completed = false
    }
        
    //复位
    function click_Reset(){
        dataObj.controls.reset();
        // dataObj.controls.saveState(); 
    }
      
    //切换
    function click_Switch(color_par){
        let color = "#666666"
        console.log(color_par)
        //不等说明是点击按钮触发，等于就是首次加载默认的
        if(color_par != 'mountedFun'){
            dataObj.if_bg_color =! dataObj.if_bg_color
            if(dataObj.if_bg_color){
                color = "#333333"
            }else{
                color = "#666666"
            }
        }
        
        console.log('color')
        console.log(color)
        set_text_color(color)
        let productColor = '0x' + color.substring(1, color.length)
        dataObj.productColor = Number(productColor)
        if(dataObj.scene){
            dataObj.scene.background = new THREE.Color( dataObj.productColor );
        }
        if(dataObj.renderer){
            dataObj.renderer.render(dataObj.scene, dataObj.camera);
        }
        
        let ThreeDShowBoxHeader = document.getElementById("ThreeDShowBoxHeader")
        ThreeDShowBoxHeader.style.background = color
        // dataObj.$parent.$parent.$parent.templateBox_background(dataObj.productColor) //调用父组件方法
    }
    
    //切换背景色时切换按钮的字体颜色
    function set_text_color(color){
        let newColor = "#000000"
        if(color == '#333333'){
            newColor = "#ffffff"
        }else{
            newColor = "#000000"
        }
        var spanElements = document.getElementsByClassName("clickText");
        for (var i = 0; i < spanElements.length; i++) {
            spanElements[i].style.color = newColor;
        }
    }
    
    //播放暂停
    function Play_Pause(){
        dataObj.controls.autoRotate =! dataObj.controls.autoRotate//是否自动旋转
    }
    
    //3d渲染的主要方法
    function pageInt(product_fun) {
        console.log('product_fun')
        console.log(product_fun)
        init(product_fun);
        render();
        function init (product_fun) {
            let clock = new THREE.Clock();		
            dataObj.scene = new THREE.Scene();
  
            // 渲染画布的盒子
            const container = document.getElementById('app_box') //显示的盒子里
  
            let innerWidth = window.innerWidth
            let innerHeight = window.innerHeight
            // dataObj.camera = new THREE.PerspectiveCamera();
            dataObj.camera = new THREE.PerspectiveCamera(45, innerWidth / innerHeight, 0.1, 1000); //盒子占比
            //设置摄像机参数
            dataObj.camera.position.set(dataObj.positionSet.x, dataObj.positionSet.z, dataObj.positionSet.default); //设置背景与元素比例 //设置相机位置
            // dataObj.camera.up.set(0, 0, 1); //Z轴正向向上
            dataObj.camera.lookAt(new THREE.Vector3(0, 0, 0));
            dataObj.camera.far = 1000;
            dataObj.camera.updateProjectionMatrix();
            //获取主程序
            dataObj.scene = new THREE.Scene();
              
            // 3d背景
            let bg_url = 'https://threejs.org/examples/textures/equirectangular/royal_esplanade_1k.hdr'
            // new RGBELoader().load(bg_url, function (texture) {
            // // texture.mapping = THREE.EquirectangularReflectionMapping;
            // // dataObj.scene.background = texture //背景图
            dataObj.scene.background = new THREE.Color( dataObj.productColor );//背景色
            // // dataObj.scene.environment = texture;
            // render();
            // 产品
            // const loader = new GLTFLoader();
            const loader = new THREE.GLTFLoader();
            
            //加载资源
            loader.load
                (
                    product_fun, // 资源
                    // 成功
                    function (gltf) {
                        const product = gltf.scene;
                        console.log("dataObj.scene")
                        console.log(dataObj.scene)
                        dataObj.scene.add(product);	
                        console.log(dataObj.scene)	
                        // 计算产品的边界框
                        const boundingBox = new THREE.Box3().setFromObject(product);
                        const center = new THREE.Vector3();
                        boundingBox.getCenter(center);
                        // 将产品的几何体对象的位置设置为中心点坐标的负值
                        product.position.set(-center.x, -center.y, -center.z);
                        render();
                        go_is_Loading_completed('加载完成')
                        // dataObj.$parent.$parent.$parent.go_is_Loading_completed()
                    },
                    // 加载过程中的回调函数
                    function ( xhr ) {
                        // console.log( (xhr.loaded / xhr.total * 100) + '% loaded' );
                        let loaded = xhr.loaded / xhr.total * 100
                        if(loaded == 100){
                            console.log(xhr)
                        }
                    },
                    // 失败
                    function ( err ) {
                        console.error( 'An error happened' );
                        go_is_Loading_completed('加载失败')
                        // dataObj.$parent.$parent.$parent.go_is_Loading_completed()
                        // dataObj.$parent.$parent.$parent.ReloadBox_show() //调用父组件方法
                    }
                );
    
            // 灯光颜色
            let lightingColor =  parseInt('0x' + dataObj.lightingColor, 16); //颜色格式 0xF6F6F0
            const directionLight1 = new THREE.DirectionalLight(lightingColor, 1);
            directionLight1.position.set(-200, 0, 0)
            directionLight1.intensity = 0.2
            dataObj.scene.add(directionLight1);
            
            const directionLight21 = new THREE.DirectionalLight(lightingColor, 1);
            directionLight21.position.set(1, 0, 0)
            directionLight21.intensity = 0.2
            dataObj.scene.add(directionLight21);
            
            const directionLight2 = new THREE.DirectionalLight(lightingColor, 1);
            directionLight2.position.set(200, 0, 0)
            directionLight2.intensity = 0.2
            dataObj.scene.add(directionLight2);
            
            //正上方			 
            const directionLight3 = new THREE.DirectionalLight(lightingColor, 1);
            directionLight3.position.set(0, 200, 0)
            directionLight3.intensity = 0.9
            dataObj.scene.add(directionLight3);
            
            const directionLight31 = new THREE.DirectionalLight(lightingColor, 1);
            directionLight31.position.set(0, 1, 0)
            directionLight31.intensity = 0.9
            dataObj.scene.add(directionLight31);
                    
            const directionLight4 = new THREE.DirectionalLight(lightingColor, 1);
            directionLight4.position.set(0, 200, 0)
            directionLight4.intensity = 0.1
            dataObj.scene.add(directionLight4);
    
            //正盖方			 
            const directionLight5 = new THREE.DirectionalLight(lightingColor, 1);
            directionLight5.position.set(0, 0, -200)
            directionLight5.intensity = 0.9
            dataObj.scene.add(directionLight5);
            
            const directionLight6 = new THREE.DirectionalLight(lightingColor, 1);
            directionLight6.position.set(0, 0, 1)
            directionLight6.intensity = 0.2
            dataObj.scene.add(directionLight6);
                    
            const directionLight61 = new THREE.DirectionalLight(lightingColor, 1);
            directionLight61.position.set(0, 0, 200)
            directionLight61.intensity = 0.2
            dataObj.scene.add(directionLight61);
            
            //添加环境光
            let Sun = new THREE.DirectionalLight(lightingColor, 1);
            Sun.position.set(0, 300, 0);
            Sun.castShadow = true;
            //环境光
            let ambientLight = new THREE.AmbientLight(lightingColor, 1);
            dataObj.scene.add(ambientLight);
            
            // 修改材质的emissive属性来调整亮度
            // dataObj.controls.material.emissive = new THREE.Color(0xffffff);
            // dataObj.controls.material.emissiveIntensity = 1;
                
            //添加一个聚光灯
            var spotLight = new THREE.SpotLight(0xffffff);
            spotLight.position.set(-30, 60, 60);
            spotLight.castShadow = true;
            dataObj.scene.add(spotLight);
            
            //使用网格Lambert材质
            // var meshMaterial = new THREE.MeshLambertMaterial({color: 0x7777ff});
            // var sphereGeometry = new THREE.SphereGeometry(14, 20, 20);
            // var sphere = new THREE.Mesh(sphereGeometry, meshMaterial);
            // dataObj.scene.add(sphere);
                
            // 渲染器
            dataObj.renderer = new THREE.WebGLRenderer({
                // canvas: document.getElementById('app_box'), //渲染器绘制其输出的画布，
                alpha: true, // 画布是否包含alpha（透明度）缓冲区。默认值为false。
                premultipliedAlpha: true, //渲染器是否会假设颜色具有 预乘alpha。默认为true。
                antialias: true, //是否执行抗锯齿。默认值为false。
                preserveDrawingBuffer: true, //是否保留缓冲区直到手动清除或覆盖。默认值为false。
                depth: true, //绘图缓冲区是否具有至少16位的 深度缓冲区。默认为true。
                autoClear: true, //定义渲染器是否应在渲染帧之前自动清除其输出。
                //以上为基础配置选项。
                //以下为高级进阶调渲染后期
                gammaFactor: 0.1, //伽马基础值
                gammaInput: true, //如果设置，那么它期望所有纹理和颜色都是预乘伽马。默认值为false。
                gammaOutput: true, //如果设置，那么它期望所有纹理和颜色需要以预乘伽马输出。默认值为false。
                shadowMap: null, //如果使用，它包含阴影贴图的引用。
                physicalCorrectLights: true, //是否使用物理上正确的照明模式。默认值为false。
                toneMapping: 0.5, //曝光值
                toneMappingExposure: 5, //色调映射的曝光级别。默认值为1。
                renderLists: [], //在内部用于处理场景对象渲染的排序
                sortObjects: true //定义渲染器是否应对对象进行排序。默认为true。   
            });
    
            dataObj.renderer.setPixelRatio(window.devicePixelRatio);
            dataObj.renderer.setSize(window.innerWidth / 1, window.innerHeight / 1); //设置产品位置
            dataObj.renderer.toneMapping = THREE.ACESFilmicToneMapping;
            dataObj.renderer.toneMappingExposure = 1;
            dataObj.renderer.outputEncoding = THREE.sRGBEncoding;
            container.appendChild(dataObj.renderer.domElement);
            dataObj.controls = new THREE.OrbitControls(dataObj.camera, dataObj.renderer.domElement);//移动控件
            dataObj.controls.addEventListener('change', render); // use if there is no animation loop
                
            dataObj.controls.enableDamping = true; // 远近拉伸,使动画循环使用时阻尼或自转 意思是否有惯性
            dataObj.controls.enabled = true; //禁用控制器
            dataObj.controls.enableRotate = true;
            dataObj.controls.enableZoom = true;//是否可以缩放
            dataObj.controls.autoRotate = true;//是否自动旋转
            dataObj.controls.enablePan = false;//是否开启右键拖拽
            // dataObj.controls.minPolarAngle = Math.PI / 4; //上下两极的可视区域最小角度
            // dataObj.controls.maxPolarAngle = 3 - (Math.PI / 4); //上下两极的可视区域的最大角度
            dataObj.controls.minDistance  = dataObj.positionSet.maximum;//设置相机距离原点的最近距离 限制物体大 镜头越近物体越大
            dataObj.controls.maxDistance  = dataObj.positionSet.minimum;//设置相机距离原点的最远距离  限制体小 镜头越远物体越小
            // // dataObj.controls.enableKeys=true;//禁止键盘控制
            // dataObj.controls.rotateSpeed=0.5;//旋转速度
            // dataObj.controls.dampingFactor = 0.5;//鼠标滚动一个单位时拉伸幅度
            // console.log(3 - (Math.PI / 4))
            // dataObj.controls.target.set(0, 0, - 0.2);
                
            dataObj.controls.update();
            window.addEventListener('resize', onWindowResize);
            // 监听Context Lost异常
            dataObj.renderer.domElement.addEventListener('webglcontextlost', (event) => {
                console.log('Context Lost');
                // dataObj.$parent.$parent.$parent.ReloadBox_show() //调用父组件方法
            });
        }
  
        //画布大小
        function onWindowResize () {
            dataObj.camera.aspect = window.innerWidth / window.innerHeight;
            dataObj.camera.updateProjectionMatrix();
            dataObj.renderer.setSize(window.innerWidth, window.innerHeight);
            render();
        }
  
        //渲染
        function render () {
            if(dataObj.renderer.render){
                dataObj.renderer.render(dataObj.scene, dataObj.camera);
            }else{
                go_is_Loading_completed('加载失败')
                // dataObj.$parent.$parent.$parent.ReloadBox_show() //调用父组件方法
            }
        }
        
        // 动画效果
        const animate = () => {
            requestAnimationFrame(animate);
            dataObj.controls.update(); //自动旋转
            if(dataObj.renderer.render){
                dataObj.renderer.render(dataObj.scene, dataObj.camera);
            }else{
                go_is_Loading_completed('加载失败')
                // that.$parent.$parent.$parent.ReloadBox_show() //调用父组件方法
            }
        }
  
        //延时加载防止资源未加载完成报错
        setTimeout(() => {
            animate();
        }, 1000)
  
        // 监听鼠标移动事件
        window.addEventListener('mousemove', function (event) {
            
        });
    }
    
    var clickSwitch = document.getElementById("clickSwitch");
    var clickReset = document.getElementById("clickReset");
    var PlayPause = document.getElementById("PlayPause");
      
    if(clickSwitch){
        clickSwitch.addEventListener("click", click_Switch);
    }
    if(clickReset){
        clickReset.addEventListener("click", click_Reset);
    }
    if(PlayPause){
        PlayPause.addEventListener("click", PlayPauseFun);
    }

    //头部切换产品按钮
    var header_click = document.getElementById("header_click");
    var commodityChoice_box = document.getElementById("commodityChoice_box");
    var commodityChoice_product = document.getElementById("commodityChoice_product");
    var product_box_img = document.getElementById("product_box_img");
    var product_img = document.getElementById("product_img");


    if(commodityChoice_box){
        commodityChoice_box.addEventListener("click", commodityChoice_boxFun);
    }
    if(commodityChoice_product){
        commodityChoice_product.addEventListener("click", commodityChoice_productFun);
    }

    //带机盒
    function commodityChoice_boxFun(){
        get_3D_obj('product_box')
    }

    //单耳机
    function commodityChoice_productFun(){
        get_3D_obj('product')
    }
      

    var current_product;
    //产品配置文件
    var ThreeD_list = [
        {
            name: 'X1',
            is_multiple: true,
            product_box:{
                img: http_3d_Url + "static/img/3D/Minigraph/product_box.png",
                gltf: http_3d_Url + "static/img/3D/X1_box_integration_04.glb",
                position_set: {
                    x: 0,
					z: 1.7, //上下角度
					default: 1.56,//首次加载默认设置的大小
					// maximum: 0.1,
					maximum: 1.53,//设置相机距离原点的最近距离 限制物体大 镜头越近物体越大
					minimum: 3.5,//设置相机距离原点的最远距离  限制体小 镜头越远物体越小
					DirectionalLight: 'F1EECF' // 灯光颜色
                }
             },
            product:{
                img: http_3d_Url + "static/img/3D/Minigraph/product.png",
                gltf: http_3d_Url + "static/img/3D/X1_pro_machine_04.glb",
                position_set: {
                    x: 0,
					z: 0, //上下角度
					default: 1.65,//首次加载默认设置的大小
					// maximum: 0.1,
					maximum: 1.2,//设置相机距离原点的最近距离 限制物体大 镜头越近物体越大
					minimum: 2.6,//设置相机距离原点的最远距离  限制物体小 镜头越远物体越小
					DirectionalLight: 'F1EECF' // 灯光颜色
                }
            }
        },
        {
            name: 'HT2',
            is_multiple: false,
            product_box:{
                img:'',
                // gltf: http_3d_Url + "static/img/3D/HT2_box_integration_01.glb",
                // position_set: {
                //     x: 0,
                //     z: 0, //上下角度
                //     default: 60,//首次加载默认设置的大小
                //     maximum: 35,//设置相机距离原点的最近距离 限制物体大 镜头越近物体越大
                //     minimum: 110,//设置相机距离原点的最远距离  限制物体小 镜头越远物体越小
                //     DirectionalLight: 'F1EECF' // 灯光颜色
                // }
                gltf: http_3d_Url + "static/img/3D/HT2_box_integration_04.glb",
                position_set: {
                    x: 0,
                    z: 0, //上下角度
                    default: 0.6,//首次加载默认设置的大小
                    maximum: 0.1,
                    // maximum: 0.38,//设置相机距离原点的最近距离 限制物体大 镜头越近物体越大
                    minimum: 1,//设置相机距离原点的最远距离  限制物体小 镜头越远物体越小
				    DirectionalLight: 'F1EECF' // 灯光颜色
                }
            }
        }
    ]
    
    //渲染
    function mountedFun() {
        clickSwitch.style.display = 'none'
        clickReset.style.display = 'none'
        PlayPause.style.display = 'none'
        faileding.style.display = 'none'
        header_click.style.display = 'none'

        console.log(dataObj)
        console.log(dataObj.position_set)
        dataObj.positionSet = position_set //背景色
        
        console.log(dataObj.positionSet)
        dataObj.closeLoading = true
        close_loading('block')//显示Loading
        console.log('product_fun')
        console.log(product_fun)
        pageInt(product_fun);  //初始换3D
        click_Switch("mountedFun") //切换背景色
        PlayPauseFun("mountedFun") //默认播放状态
    }
    
    //销毁
    function beforeunloadFun() {
        destroy3D('close') //跳出当前页面，销毁3D
    }
    
    window.addEventListener("beforeunload", function(event) {
        // 在这里执行你的操作，比如发送请求或显示提示信息
        // 注意：在某些浏览器中，你可能无法自定义提示信息，浏览器会显示默认的提示信息
        // 你可以返回一个字符串来自定义提示信息，但并不是所有浏览器都支持
        destroy3D('close') //跳出当前页面，销毁3D
    });

    var ThreeDShowBox = document.getElementById("ThreeDShowBox"); //3d展示弹窗
    var ThreeDShowBoxHeaderClose = document.getElementById("ThreeDShowBoxHeaderClose"); //关闭3d展示弹窗
    var go_loading = document.getElementById("go_loading"); //加载失败，重新加载

    //加载失败，重新加载
    if(go_loading){
        go_loading.addEventListener("click", mountedFun);
    }
    

    //获取产品对应的3d文件 显示
    function ClickThreeDFun(event){
        console.log('event')
        var name = event.currentTarget.getAttribute("data-name");
        // 在这里可以使用参数进行后续操作
        console.log("点击的name参数是：" + name);
      
        selectName(name)
    }

    //获取当前产品的3d文件
    function selectName(name){
        ThreeD_list.forEach((item, index)=>{
            if(item.name == name){
                current_product = item
            }
        })
        console.log('current_product')
        console.log(current_product)
        if(current_product){
            get_3D_obj('product_box')
        }
    }

    //获取产品点击对应的文件
    function get_3D_obj(name){
        destroy3D('get_3D_obj')
        destroy3D(name)
        console.log(name)
        var obj = current_product[name]
        product_fun = obj.gltf
        position_set =  obj.position_set
        if(ThreeDShowBox){
            ThreeDShowBox.style.display = 'block'
        }
        if(name == 'product_box'){
            commodityChoice_box.classList.add("shallow_image");
            commodityChoice_box.classList.remove("deep_image");

            commodityChoice_product.classList.add("deep_image");
            commodityChoice_product.classList.remove("shallow_image");
        }else{
            commodityChoice_box.classList.remove("shallow_image");
            commodityChoice_box.classList.add("deep_image");

            commodityChoice_product.classList.remove("deep_image");
            commodityChoice_product.classList.add("shallow_image");
        }

        if(!product_fun || product_fun == ''){
            go_is_Loading_completed('加载失败')
        }else{
            mountedFun()//代码片段的加载3d
        }
    }

    //关闭3d展示弹出框
    function close_view(event){
        console.log('event')
        destroy3D('close') //跳出当前页面，销毁3D
    }

    //产品图上的3d按钮
    var ClickThreeD = document.getElementById("ClickThreeD");
    console.log('ClickThreeD')
    console.log(ClickThreeD)
    if(ClickThreeD){
        ClickThreeD.addEventListener("click", ClickThreeDFun);
    }

    //点击关闭3d展示弹窗
    if(ThreeDShowBoxHeaderClose){
        ThreeDShowBoxHeaderClose.addEventListener("click", close_view);
    }

    